// extracted by mini-css-extract-plugin
export default {"ordertabs":"PageTabs_ordertabs__PaJxF","active":"PageTabs_active__7W74y"};